import { render, staticRenderFns } from "./AssociationLinkage.vue?vue&type=template&id=bff1d680&scoped=true"
import script from "./AssociationLinkage.vue?vue&type=script&lang=js"
export * from "./AssociationLinkage.vue?vue&type=script&lang=js"
import style0 from "./AssociationLinkage.vue?vue&type=style&index=0&id=bff1d680&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff1d680",
  null
  
)

export default component.exports